import { render, staticRenderFns } from "./WarehouseViewLogs.vue?vue&type=template&id=0c23d165&"
import script from "./WarehouseViewLogs.vue?vue&type=script&lang=js&"
export * from "./WarehouseViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports